/*
 * Copyright (c) 2026 Talent Catalog.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License
 * for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see https://www.gnu.org/licenses/.
 */

import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {CandidateService} from '../../../../../services/candidate.service';
import {IntakeComponentBase} from '../../../../util/intake/IntakeComponentBase';
import {CandidateExam} from "../../../../../model/candidate";

@Component({
  selector: 'app-ielts-level',
  templateUrl: './ielts-level.component.html',
  styleUrls: ['./ielts-level.component.scss']
})
export class IeltsLevelComponent extends IntakeComponentBase implements OnInit {

  @Input() selectedIndex: number;

  constructor(fb: UntypedFormBuilder, candidateService: CandidateService) {
    super(fb, candidateService);
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      ieltsLevel: [null]
    });
  }

  get englishExams(): CandidateExam[] {
    return this.candidateIntakeData?.candidateExams;
  }
}
